import { User } from 'model';
import React from 'react';
import { IonButton, IonRouterLink, IonText } from '@ionic/react';
import styles from './PreviewUser.module.css';
import { useCountPostsByAuthorQuery } from '../api/PostApi';
import { UserItem } from './admin/UserItem';
import { SkeletonLoader } from './SkeletonLoader';
import { useGetAdminProfileQuery } from '../api/UserApi.js';
import { IconAlert } from './QuirkIcons/index.js';

export interface PreviewUserProps {
	userId: User['_id'];
}

export const PreviewUser: React.FC<PreviewUserProps> = ({ userId }: PreviewUserProps) => {
	const {
		data: user,
		isLoading: isLoadingUser,
		isError
	} = useGetAdminProfileQuery(userId, {
		skip: userId === ''
	});
	const { data, isLoading: isLoadingPosts } = useCountPostsByAuthorQuery(userId);
	const isLoading = isLoadingPosts || isLoadingUser;
	const totalPosts = data?.response ?? 0;
	return (
		<div className={styles.PreviewUser}>
			<SkeletonLoader height={'160px'}>
				{!isLoading ? (
					<>
						{user && !isError && (
							<>
								<UserItem user={user} />
								<div className={styles.email}>{user.email}</div>
								<div className={styles.totalPosts}>
									<IonRouterLink routerLink={`/main/latest/${user._id}`}>
										<IonButton
											color="primary"
											fill="solid"
											size="default"
											className="radius8"
											expand="block"
										>
											<>View {totalPosts} posts</>
										</IonButton>
									</IonRouterLink>
								</div>
							</>
						)}
						{isError && (
							<div className={styles.error}>
								<IonText>Error loading user</IonText>
								<IconAlert />
							</div>
						)}
					</>
				) : null}
			</SkeletonLoader>
		</div>
	);
};
